<template>
  <div class="container-fluid nav_bar">
    <!-- desktop mode -->
    <div class="desktop d-flex flex-row justify-content-between">
      <div class="brand p-3">
        <img alt="sky logo" src="../assets/images/sky-logo.svg">
      </div>
      <div class="flex-grow-1 d-flex flex-column justify-content-between">
        <!-- version -->
        <div class="flex-grow-1 d-flex flex-row justify-content-end pt-1 text-secondary" style="font-size: 10px">
          {{ appVersion }}
        </div>
        <!-- account -->
        <div class="flex-grow-1 d-flex flex-row justify-content-end pl-3 pr-3">
          <b-icon class="my_account mt-3 mr-3 clickable"
                  icon="person-circle"
                  v-on:click.prevent="onClickAccount">
          </b-icon>
        </div>
        <!-- main navigation -->
        <div class="pl-3 pr-3 d-flex flex-row justify-content-between">
          <div class="d-flex flex-grow-1 justify-content-center">
            <div v-for="option in mNavigationOption.options" v-bind:key="option.value">
              <div class="nav_button selected clickable"
                   :class="{'nav_button-selected': mNavigationOption.selected === option.value}"
                   v-on:click.prevent="onClickOption(option.value)">
                {{option.text}}
              </div>
              <div v-if="mNavigationOption.selected === option.value" class="nav_button-selected-underline"></div>
            </div>
          </div>
          <div class="nav_button clickable"
              v-on:click.prevent="onClickHelp">
            {{ navHelp.text }}
          </div>
        </div>
      </div>
    </div>
    <!-- mobile mode -->
    <div class="mobile d-flex flex-row justify-content-between">
      <div class="brand">
        <img alt="sky logo" src="../assets/images/sky-logo.svg">
      </div>
      <!-- selected option -->
      <label class="mt-4">{{ selectedPage.text }}</label>

      <!-- menu click-->
      <b-icon class="my_menu_list_trigger open mt-3 mr-1 clickable"
              icon="list"
              v-on:click.prevent="onClickMenuList">
      </b-icon>
    </div>
    <!-- mobile menu nav -->
    <div id="nav_bar_mobile" v-if="windowWidth < 768" class="mobile nav_bar_mobile">
      <div style="width: 100%; text-align: right">
        <b-icon class="my_menu_list_trigger close mt-3 mr-3 clickable"
                icon="x"
                v-on:click.prevent="onClickMenuList">
        </b-icon>
        <div class="" style="margin-top: 6rem; margin-right: 2rem;">
          <div class="side_button clickable mt-2 pt-2 pb-2"
               :class="{'side_button-selected': mSideOption.selected === option.value}"
               v-on:click.prevent="onClickSideOption(option)"
               v-for="option in mSideOption.options" v-bind:key="option.value">
            {{option.text}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Diagnostics from "@/views/content/diagnostics"
import Inventory from "@/views/content/inventory"
import logger from "@/util/logger"

const LOG_TAG = 'nav_bar';

export default {
  name: LOG_TAG,
  props: {
    navOptions: {
      type: Array,
      required: true,
      default: function () {
        //{text: '', value: '', type: 'help', 'account'}
        return [];
      }
    },
    navHelp: {
      type: Object,
      default: function () {
        //{text: '', value: '', type: 'help', 'account'}
        return {
          text: 'Help',
          value: 'help'
        };
      }
    },
    navAccount: {
      type: Object,
      default: function () {
        //{text: '', value: '', type: 'help', 'account'}
        return {
          text: 'Account',
          value: 'account'
        };
      }
    }
  },
  data() {
    return {
      mNavigationOption: {
        options: [],
        selected: '',
      },
      mOpenMobileMenu: false,

      mSideOption: {
        options: [
          {text: Diagnostics.display, value: Diagnostics.route},
          {text: Inventory.display, value: Inventory.route},
        ],
      }
    };
  },
  watch: {
    windowWidth: function (value) {
      const vm = this;
      if (value >= 768) {
        vm.mOpenMobileMenu = false;
      } else {
        const defaultOptions = vm.mNavigationOption.options[0];
        if (defaultOptions && vm.mNavigationOption.selected !== defaultOptions.value) {
          // vm.onClickOption(defaultOptions.value);
        }
      }
    },
    selectedPage: function (value) {
      const vm = this;
      logger.d(LOG_TAG, 'watch', 'selectedPage', value.value);
      const optionChange = vm.navOptions.find((option) => value.value ? value.value.includes(option.value) : false);
      if (optionChange && optionChange !=vm.mNavigationOption.selected) {
        vm.mNavigationOption.selected = optionChange.value;
      }
    },
  },
  computed: {
    appVersion() {
      return this.$store.state.appVersion;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    selectedPage() {
      return this.$store.state.selectedPage;
    },
  },
  mounted() {
    const vm = this;

    if (vm.navOptions.length > 0) {
      vm.navOptions.forEach((option) => {
        vm.mNavigationOption.options.push(option);
      });
      const defaultTab = vm.navOptions.find((option) => vm.$route.name.includes(option.value));
      logger.d(LOG_TAG, 'mounted', vm.$route.name, defaultTab);
      vm.mNavigationOption.selected = defaultTab ? defaultTab.value : null;
    }
  },
  methods: {
    onClickOption(value) {
      const vm = this;
      logger.d(LOG_TAG, 'onClickOption', value);
      vm.$store.commit('setSelectedPage', {text: '', value: ''});

      vm.mNavigationOption.selected = value;
      vm.$emit('click', value);
    },
    onClickHelp() {
      // const vm = this;
      // logger.d(LOG_TAG, 'onClickHelp');
      // vm.$store.commit('setSelectedPage', {text: '', value: ''});

      // vm.mNavigationOption.selected = vm.navHelp.value;
      // vm.$emit('click', vm.navHelp.value);
    },
    onClickAccount() {
      // const vm = this;
      // logger.d(LOG_TAG, 'onClickAccount');
      // vm.$store.commit('setSelectedPage', {text: '', value: ''});

      // vm.mNavigationOption.selected = vm.navAccount.value;
      // vm.$emit('click', vm.navAccount.value);
    },
    onClickMenuList() {
      const vm = this;
      //logger.d(LOG_TAG, 'onClickMenuList');
      vm.$emit('click', 'open_menu');
      vm.mOpenMobileMenu = !vm.mOpenMobileMenu;
      if (vm.mOpenMobileMenu) {
        document.getElementById("nav_bar_mobile").style.width = '75%';
      } else {
        document.getElementById("nav_bar_mobile").style.width = '0';
      }
    },
    onClickSideOption(option) {
      //
      const vm = this;
      logger.d(LOG_TAG, 'onClickSideOption', vm.$route.name, option.value);
      vm.onClickMenuList();
      if (vm.$route.name !== option.value) {
        vm.$store.commit('setSelectedPage', option);
        vm.$router.push({name: option.value});
      }
    }
  }
}
</script>
<style scoped>
.nav_bar {
  height: 8rem;
  border-bottom: 0.1rem solid lightgrey;
}
.nav_bar .desktop {
  display: flex !important;
  height: 100%;
}
.nav_bar .mobile {
  display: none !important;
  height: 0;
}
.nav_bar .mobile label {
  font-weight: bold;
  text-transform: uppercase;
}
.brand {
  max-width: 16rem;
  height: 100%;
}
.brand img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.my_account {
  width: 2.5em;
  height: 2.5em;
  color: darkgrey;
}
.my_menu_list_trigger {
  width: 2.5em;
  height: 2.5em;
  opacity: 1;
}
.my_menu_list_trigger.open {
  color: black;
}
.my_menu_list_trigger.close {
  color: white;
}
.nav_button {
  display: block;
  text-align: center;
  padding: 12px 16px;
  color: darkgrey;
  text-decoration: none;
}
.nav_button-selected {
  color: var(--primary);
}
.nav_button:hover {
  color: dimgray;
}
.nav_button-selected-underline {
  height: 2px;
  background-color: var(--primary-highlight);
}
.nav_bar_mobile {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1;
  top: 0;
  right: 0;
  background-color: #111;
  overflow-x: hidden;
  transition: .3s;
}

.side_button {
  display: block;
  width: 100%;
  color: white;
  font-size: 2em;
  font-weight: bold;
  text-align: center;
  text-decoration: none;
  border-top-right-radius: 6rem;
  border-bottom-right-radius: 6rem;
}
.side_button:hover {
  color: var(--primary);
  background-color: var(--primary-highlight-background);
}
.side_button-selected {
  color: var(--primary-highlight);
  background-color: var(--primary-highlight-background);
}

@media screen and (max-width: 767px) {
  .nav_bar {
    height: 4rem;
  }
  .nav_bar .desktop {
    display: none !important;
    height: 0;
  }
  .nav_bar .mobile {
    display: flex !important;
    height: 100%;
  }
  .brand {
    max-width: 4rem;
    height: 100%;
  }
}
</style>
